import { render, staticRenderFns } from "./edit-third-lab-modal.vue?vue&type=template&id=c96c383a"
import script from "./edit-third-lab-modal.vue?vue&type=script&lang=js"
export * from "./edit-third-lab-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports